import fetch from 'isomorphic-fetch'
import { RSAA, RSAAAction } from 'redux-api-middleware'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { DeliverySlot } from '../reducers/delivery'
import { queryString } from '@cinch/oxd-utils/requests/src'

import { ERROR_DELIVERY_SLOTS, RECEIVE_DELIVERY_SLOTS, REQUEST_DELIVERY_SLOTS, SELECT_DELIVERY_SLOT } from '../types'

const DELIVERY_SLOT_AVAILABILITY_SERVICE_URL = getEnv(Env.DeliverySlotAvailabilityServiceUrl)

type GetDeliverySlots = (postcode: string) => RSAAAction<null, object, null>

export const getDeliverySlots: GetDeliverySlots = (postcode) => {
  return {
    [RSAA]: {
      endpoint: `${DELIVERY_SLOT_AVAILABILITY_SERVICE_URL}/availability?${queryString({ postcode })}`,
      method: 'GET',
      fetch,
      types: [REQUEST_DELIVERY_SLOTS, RECEIVE_DELIVERY_SLOTS, ERROR_DELIVERY_SLOTS],
    },
  }
}

export const selectDeliverySlot = (payload: DeliverySlot) => {
  return {
    type: SELECT_DELIVERY_SLOT,
    payload,
  }
}
